
export class EmailStatusFilter {
    status = '';

    initFromJson(json) {
       this.status = json.status;
    }

    isEmpty() {
        return this.status.length === 0;

    }
}
